// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"176":"32c3d7d4","728":"4fbc7e15","776":"505ef625"}[chunkId] + ".chunk.css";
};